export const formatSalaryGBP = (salary, job_type = '') => {
  if (!salary || salary === 'N/A' || salary === 'null' || salary === 'undefined') {
    return 'Competitive';
  }

  let result = String(salary).trim();

  if (!result || result === '0') {
    return 'Competitive';
  }

  // Convert GBP to £
  result = result.replace(/^GBP\s*/i, '£');

  // Fix duplicated single salary ranges: £33,183 - £33,183 -> £33,183
  const duplicateRangeMatch = result.match(/^£?\s*([\d,]+)\s*[-–]\s*£?\s*\1$/);
  if (duplicateRangeMatch) {
    result = `£${duplicateRangeMatch[1]}`;
  }

  // Add £ if salary starts with a number
  if (/^\d/.test(result)) {
    result = `£${result}`;
  }

  const isPartTime =
    typeof job_type === 'string' &&
    ['part-time', 'part time'].includes(job_type.toLowerCase());

  let alreadyHasPeriod = /\b(?:per|an?)\s+(?:hour|day|week|month|annum|year)\b|\b(?:hourly|daily|weekly|monthly|annually|pro rata)\b/i.test(result);
  const salaryValues = [...result.matchAll(/(?:£\s*)?([\d,]+(?:\.\d+)?)/g)]
    .map(match => Number(match[1].replace(/,/g, '')))
    .filter(Number.isFinite);
  const looksHourly = salaryValues.length > 0 && Math.max(...salaryValues) < 100;

  // Older imports did not retain Reed's salary period. A value such as £13
  // cannot be an annual salary, so make the safe unit explicit on existing jobs.
  if (!alreadyHasPeriod && looksHourly) {
    result = `${result} per hour`;
    alreadyHasPeriod = true;
  }

  if (isPartTime && result !== 'Competitive' && !alreadyHasPeriod) {
    result = `${result} pro rata`;
  }

  return result;
};
